import React from 'react';
import { combineClassNames } from '@utils/combineClassNames';

type Dimension = number | string | undefined;

type SkeletonProps = {
  width?: Dimension;
  height?: Dimension;
  circle?: boolean;
  inline?: boolean;
  className?: string;
  style?: React.CSSProperties;
};

const toCssSize = (value?: number | string) => {
  if (value === undefined) return undefined;
  return typeof value === 'number' ? `${value}px` : value;
};

export const Skeleton: React.FC<SkeletonProps> = ({
  width,
  height,
  circle,
  inline = true,
  className,
  style,
}) => {
  const styles: React.CSSProperties = {
    width: toCssSize(width),
    height: toCssSize(height),
    ...style,
  };

  return (
    <span
      className={combineClassNames(
        inline ? 'tw-inline-block' : 'tw-block',
        'tw-bg-gray-200 tw-rounded tw-animate-pulse',
        circle ? 'tw-rounded-full' : '',
        className,
      )}
      style={styles}
    />
  );
};

export default Skeleton;

